import Keycloak from "keycloak-js";
import { IAuthInterface } from "@gwn/guac-lib";
import { loginUrlKey } from "../constants/authConstants";

/**
 * Creates auth interaface based on keycloak
 */
export const createKeycloakInterface = (keycloak: Keycloak | undefined): IAuthInterface => {
  const userRoles: Array<string> = keycloak?.tokenParsed?.resource_access?.account?.roles || [];
  const userEmail: string = keycloak?.tokenParsed?.email || "";

  const isUserRoleMember = (groupName: string): boolean => {
    return userRoles.includes(groupName);
  };

  const getToken = () => {
    if (!keycloak?.tokenParsed) return {};

    return {
      ...keycloak.tokenParsed,
    };
  };

  const getJwt = () => {
    return keycloak?.token || "";
  };

  const parseLoginUrl = (idp, redirectUri) => {
    const evalIdp = idp || getToken().idp || "";
    let reloginIdp: any;

    if (typeof evalIdp === "object") {
      reloginIdp = evalIdp.name;
    } else {
      reloginIdp = evalIdp;
    }

    let loginUrl = redirectUri || window.location.origin;

    if (reloginIdp) {
      loginUrl += `/?idp=${reloginIdp}`;
    }

    return loginUrl;
  };

  const cacheLoginUrl = (idp, redirectUri) => {
    localStorage.setItem(loginUrlKey, parseLoginUrl(idp, redirectUri));
  };

  const logout = (idp, redirectUri) => {
    const logoutParams = {
      redirectUri: `${window.location.origin}/p/logout`,
    };

    cacheLoginUrl(idp, redirectUri);

    keycloak?.logout(logoutParams);
  };

  return {
    logout: logout,
    isTokenExpired: keycloak?.isTokenExpired,
    isUserRoleMember,
    getToken,
    getJwt,
    userRoles,
    userEmail,
  };
};
